import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Skype(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.59 2a5.61 5.61 0 012.621.658 9.506 9.506 0 011.794-.169 9.37 9.37 0 013.676.744 9.456 9.456 0 013 2.028 9.441 9.441 0 012.023 3.01 9.427 9.427 0 01.743 3.685 9.66 9.66 0 01-.156 1.715h-.001v.001l-.001.001-.018.1a.446.446 0 00.01-.05l.008-.05.146.281c.32.666.51 1.39.555 2.127l.01.316a5.577 5.577 0 01-1.637 3.962A5.552 5.552 0 0116.41 22a5.588 5.588 0 01-2.75-.729l.002.001c-.005.002-.006.001-.006.001l-.405.063a9.371 9.371 0 01-4.919-.66 9.438 9.438 0 01-3.004-2.028 9.443 9.443 0 01-2.766-6.69c0-.549.047-1.097.141-1.633v.002l-.002-.01A5.634 5.634 0 012 7.603c0-1.496.583-2.905 1.637-3.962A5.55 5.55 0 017.59 2zm4.255 3.77c-2.242 0-4.629.955-4.629 3.495 0 1.226.438 2.53 2.84 3.133l2.985.747c.902.223 1.128.733 1.128 1.19 0 .764-.757 1.512-2.128 1.512-2.68 0-2.305-2.067-3.743-2.067-.644 0-1.113.447-1.113 1.08 0 1.242 1.5 2.894 4.856 2.894 3.19-.001 4.773-1.544 4.773-3.607 0-1.331-.613-2.748-3.031-3.289l-2.212-.493c-.84-.191-1.809-.446-1.809-1.24 0-.796.676-1.351 1.903-1.351 2.469 0 2.243 1.7 3.469 1.7.645 0 1.211-.38 1.211-1.034 0-1.528-2.434-2.67-4.5-2.67z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Skype);
export default ForwardRef;